import clsx from "clsx";
import { Cell, Pie, PieChart } from "recharts";
import Typography from "./Typography";

export type RatioPieChartProps = {
    portion: number;
    total: number;
    className?: string;
};

const RatioPieChart = ({ portion, total, className }: RatioPieChartProps) => {
    const data = [
        { value: portion, color: "#1F3135" },
        { value: total - portion, color: "#369A8A" },
    ];

    const percentage = Math.round(((total - portion) / total) * 100);

    if (isNaN(percentage)) return <div className="h-[70px]" />;

    return (
        <div className={clsx("relative", className)}>
            <PieChart width={70} height={70}>
                <Pie
                    dataKey="value"
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={25}
                    outerRadius={35}
                    fill="#82ca9d"
                    stroke="none"
                    style={{
                        border: "none",
                    }}
                >
                    {data.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={entry.color}
                            style={{ border: "none" }}
                        />
                    ))}
                </Pie>
            </PieChart>
            <Typography
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[18px]"
                variant="label-large"
                component="label"
            >
                {percentage}
                <span className="text-[12px]">%</span>
            </Typography>
        </div>
    );
};

export default RatioPieChart;
